(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[599],{

/***/ 2722:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mapa-do-site",
      function () {
        return __webpack_require__(561);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ mapa_do_site_index_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/Layout/Default/index.tsx + 1 modules
var Default = __webpack_require__(7309);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./pages/comprar-grama/index.page.js + 1 modules
var index_page = __webpack_require__(1171);
// EXTERNAL MODULE: ./services/grass/index.ts + 1 modules
var grass = __webpack_require__(7493);
// EXTERNAL MODULE: ./services/tips/index.ts
var services_tips = __webpack_require__(8134);
// EXTERNAL MODULE: ./utils/estados-cidades.js
var estados_cidades = __webpack_require__(2487);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 6 modules
var polished_esm = __webpack_require__(7573);
// EXTERNAL MODULE: ./styles/stitches.config.ts
var stitches_config = __webpack_require__(4767);
;// CONCATENATED MODULE: ./pages/mapa-do-site/styles.ts


var WrapLink = (0,stitches_config/* styled */.zo)("div", {
    "ul": {
        marginLeft: (0,polished_esm/* rem */.hO)(20),
        listStyle: "none"
    },
    "a": {
        margin: (0,polished_esm/* rem */.hO)(5),
        marginLeft: (0,polished_esm/* rem */.hO)(40),
        display: "block",
        fontFamily: "$domine",
        fontSize: (0,polished_esm/* rem */.hO)(20),
        color: "$emerald600"
    },
    "li": {
        marginBottom: (0,polished_esm/* rem */.hO)(5),
        "a": {
            display: "inline",
            fontSize: (0,polished_esm/* rem */.hO)(16),
            color: "$grey800",
            borderBottom: "dotted 1px #333"
        }
    }
});

;// CONCATENATED MODULE: ./pages/mapa-do-site/index.page.tsx








var SiteMap = function() {
    var ref = (0,grass/* useGrass */.x)(), grasses = ref.data;
    var ref1 = (0,services_tips/* useList */.s)(), tips = ref1.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Default/* default */.Z, {
        category: "Mapa do site | Central da Grama",
        categorySize: "25px",
        title: "Mapa do site",
        description: "Navegue mais facilmente em todas as p\xe1ginas do site, como por exemplo selecionando diretamente a cidade que deseja seu or\xe7amento.",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapLink, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        title: "P\xe1gina Inicial",
                        children: "P\xe1gina Inicial"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/fotos",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        title: "Fotos",
                        children: "Fotos"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/contato",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        title: "Contato",
                        children: "Contato"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/#gramas",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        title: "Gramas",
                        children: "Gramas"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: grasses === null || grasses === void 0 ? void 0 : grasses.map(function(item) {
                        var ref, ref1;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/".concat(item === null || item === void 0 ? void 0 : item.slug),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    title: item === null || item === void 0 ? void 0 : (ref = item.title) === null || ref === void 0 ? void 0 : ref.rendered,
                                    children: item === null || item === void 0 ? void 0 : (ref1 = item.title) === null || ref1 === void 0 ? void 0 : ref1.rendered
                                })
                            })
                        }, item.id);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/dicas",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        title: "Dicas",
                        children: "Dicas"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: tips === null || tips === void 0 ? void 0 : tips.map(function(item) {
                        var ref, ref1;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/dicas/".concat(item === null || item === void 0 ? void 0 : item.slug),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    title: item === null || item === void 0 ? void 0 : (ref = item.title) === null || ref === void 0 ? void 0 : ref.rendered,
                                    children: item === null || item === void 0 ? void 0 : (ref1 = item.title) === null || ref1 === void 0 ? void 0 : ref1.rendered
                                })
                            })
                        }, item.id);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/comprar-grama",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        title: "Comprar Grama",
                        children: "Comprar Grama"
                    })
                }),
                estados_cidades/* default.map */.Z.map(function(state) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/comprar-grama/".concat(state === null || state === void 0 ? void 0 : (ref = state.sigla) === null || ref === void 0 ? void 0 : ref.toLocaleLowerCase()),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        title: "comprar grama ".concat(state.nome),
                                        children: state.nome
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    children: state.cidades.map(function(city) {
                                        var ref;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/comprar-grama/".concat(state === null || state === void 0 ? void 0 : (ref = state.sigla) === null || ref === void 0 ? void 0 : ref.toLocaleLowerCase(), "/").concat((0,index_page.transformarParaUrlAmigavel)(city)),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    title: "Comprar grama ".concat(city, " ").concat(state === null || state === void 0 ? void 0 : state.sigla),
                                                    children: city
                                                })
                                            })
                                        }, city);
                                    })
                                })
                            })
                        ]
                    }, state.sigla);
                })
            ]
        })
    });
};
/* harmony default export */ var mapa_do_site_index_page = (SiteMap);


/***/ }),

/***/ 7493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ useGrass; }
});

// UNUSED EXPORTS: useGrassById

// EXTERNAL MODULE: ./services/api.ts
var services_api = __webpack_require__(9419);
;// CONCATENATED MODULE: ./services/grass/action.ts

var getGrass = function() {
    return services_api/* api.get */.hi.get("/grass").then(function(response) {
        return response.data;
    });
};
var action_getDetailsGrass = function(id) {
    return api.get("/grass/?slug=".concat(id)).then(function(response) {
        return response.data[0];
    });
};

// EXTERNAL MODULE: ./utils/useRequest.ts
var utils_useRequest = __webpack_require__(7243);
;// CONCATENATED MODULE: ./services/grass/index.ts


var useGrass = function() {
    return (0,utils_useRequest/* useRequest */.Q)(getGrass);
};
var useGrassById = function(id) {
    return useRequest(getDetailsGrass, id);
};


/***/ }),

/***/ 9628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ getList; }
/* harmony export */ });
/* unused harmony export getDetail */
/* harmony import */ var services_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9419);

var getList = function() {
    return services_api__WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/posts", {
        params: {
            per_page: 20
        }
    }).then(function(response) {
        return response.data;
    });
};
var getDetail = function(id) {
    return api.get("/posts/?slug=".concat(id)).then(function(response) {
        return response.data[0];
    });
};


/***/ }),

/***/ 8134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ useList; }
/* harmony export */ });
/* harmony import */ var _action__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9628);
/* harmony import */ var utils_useRequest__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7243);


var useList = function() {
    return (0,utils_useRequest__WEBPACK_IMPORTED_MODULE_1__/* .useRequest */ .Q)(_action__WEBPACK_IMPORTED_MODULE_0__/* .getList */ .g);
};


/***/ }),

/***/ 7243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ useRequest; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7568);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



var useRequest = function(requestData, params) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), data = ref[0], setData = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), success = ref2[0], setSuccess = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), error = ref3[0], setError = ref3[1];
    var request = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    setError(null);
                    setSuccess(false);
                    setIsLoading(true);
                    _ctx.prev = 3;
                    _ctx.next = 6;
                    return requestData(params);
                case 6:
                    response = _ctx.sent;
                    setData(response);
                    setSuccess(true);
                    _ctx.next = 15;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](3);
                    setSuccess(false);
                    setError(_ctx.t0);
                case 15:
                    _ctx.prev = 15;
                    setIsLoading(false);
                    return _ctx.finish(15);
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                3,
                11,
                15,
                18
            ]
        ]);
    })), [
        params,
        requestData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        request();
    }, [
        request
    ]);
    return {
        data: data,
        error: error,
        success: success,
        isLoading: isLoading
    };
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [753,921,112,434,861,774,888,179], function() { return __webpack_exec__(2722); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);